import { createAsyncThunk } from '@reduxjs/toolkit'
import { BillType } from '../all-types'
import { axiosClient } from '../api'
import { URLS } from '../constants'
import {
  getCurrentTimeInfo,
  getFilenameFromContentDisposition,
  isResponseSuccess,
  triggerBrowserDownload,
} from '../utils'
import { AppConfig } from '../config'

export const createNewBill = createAsyncThunk(
  'bill/createNewBill',
  async (details: { bill: BillType }, { dispatch, rejectWithValue }) => {
    try {
      const timeInfo = getCurrentTimeInfo()
      const uniqueBillNo = String(timeInfo.year).concat(
        String(timeInfo.timestamp)
      ) //TODO

      details.bill = {
        ...details.bill,
        clientId: AppConfig.getCLientId() || '',
        billNo: uniqueBillNo,
        timeInfo: {
          billDate: timeInfo.date,
          billTime: timeInfo.time,
          timestamp: String(timeInfo.timestamp),
          timezone: timeInfo.timezone || '',
          year: timeInfo.year,
        },
      }

      const response = await axiosClient.post(`${URLS.CREATE_BILL}`, {
        bill: details.bill,
      })
      if (!isResponseSuccess(response.status)) {
        throw new Error('Failed to save printer configuration.')
      }
      return response.data.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const getBills = async (startTime: number, endTime: number) => {
  try {
    const response = await axiosClient.post(
      URLS.GET_BILLS(startTime, endTime),
      {},
      { params: { startTime, endTime } }
    )
    if (!isResponseSuccess(response.status)) {
      throw new Error('Failed to get bills')
    }
    return response.data.data
  } catch (err: any) {
    console.error(err)
  }
}

export const createLatestBill = createAsyncThunk(
  'bill/createLatestBill',
  async (details: { bill: BillType }, { dispatch, rejectWithValue }) => {
    try {
      const timeInfo = getCurrentTimeInfo()
      const uniqueBillNo = String(timeInfo.year).concat(
        String(timeInfo.timestamp)
      ) //TODO

      details.bill = {
        ...details.bill,
        clientId: AppConfig.getCLientId() || '',
        billNo: uniqueBillNo,
        timeInfo: {
          billDate: timeInfo.date,
          billTime: timeInfo.time,
          timestamp: String(timeInfo.timestamp),
          timezone: timeInfo.timezone || '',
          year: timeInfo.year,
        },
      }

      const response = await axiosClient.post(`${URLS.CREATE_BILL}`, {
        bill: details.bill,
      })
      if (!isResponseSuccess(response.status)) {
        throw new Error('Failed to save printer configuration.')
      }
      return response.data.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const handleModifyBill = async (bill: BillType) => {
  try {
    const response = await axiosClient.post(
      URLS.MODIFY_BILL, {bill: bill}
    )

    if (!isResponseSuccess(response.status)) {
      throw new Error('Failed to update bill status for takeaway orders')
    }

    return response.data.data
  } catch (err: any) {
    console.error(err)
  }
}


export const updateTakeawayBillStatus = async (id: string, status: string) => {
  try {
    const response = await axiosClient.post(
      URLS.UPDATE_TAKEAWAY_BILL_STATUS(id, status)
    )

    if (!isResponseSuccess(response.status)) {
      throw new Error('Failed to update bill status for takeaway orders')
    }

    return response.data.data
  } catch (err: any) {
    console.error(err)
  }
}

export const downloadBill = async (
  clientId: string,
  from: string,
  to: string
) => {
  try {
    const response = await axiosClient.get(
      URLS.DOWNLOAD_BILL(clientId, from, to),
      {
        responseType: 'blob',
      }
    )

    const cd = response.headers?.['content-disposition'] as string | undefined;
    
    const suggested =
      getFilenameFromContentDisposition(cd) || `bill_${from}_${to}.pdf`

    const blob = new Blob([response.data], { type: 'application/pdf' })
    triggerBrowserDownload(blob, suggested)

    return response.data.data
  } catch (err: any) {
    console.error(err)
  }
}

export const updateBillPaymentMode = async (billId: string, paymentMode: string) => {
  try {
    const response = await axiosClient.post(
      URLS.UPDATE_BILL_PAYMENT_MODE(billId, paymentMode)
    )

    if (!isResponseSuccess(response.status)) {
      throw new Error('Failed to update bill Payment Mode for the Bill')
    }

    return response.data.data;
  } catch (err: any) {
    console.error(err)
  }
}


export const deleteBillAPI = async (billId: string) => {
  try {
    const response = await axiosClient.post(
      `${URLS.DELETE_BILL}?id=${billId}`
    )

    if (!isResponseSuccess(response.status)) {
      throw new Error('Failed to delete the bill')
    }

    return response.data.data;
  } catch (err: any) {
    console.error(err)
  }
}

